/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppEmbeddedSignupActivate } from '../../axios/whatsAppEmbeddedSignupActivate'
import type {
	WhatsAppEmbeddedSignupActivateError,
	WhatsAppEmbeddedSignupActivatePathParams,
	WhatsAppEmbeddedSignupActivateResponse,
} from '../../types/WhatsAppEmbeddedSignupActivate'

export const whatsAppEmbeddedSignupActivateMutationKey = () =>
	[{ url: '/organisations/:organisationId/whatsapp-account/activate' }] as const

export type WhatsAppEmbeddedSignupActivateMutationKey = ReturnType<typeof whatsAppEmbeddedSignupActivateMutationKey>

export type WhatsAppEmbeddedSignupActivateVariables = {
	organisationId: WhatsAppEmbeddedSignupActivatePathParams['organisationId']
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppEmbeddedSignupController.php WhatsAppEmbeddedSignupController::activate */
export function useWhatsAppEmbeddedSignupActivate<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppEmbeddedSignupActivateResponse,
		AxiosError<WhatsAppEmbeddedSignupActivateError>,
		WhatsAppEmbeddedSignupActivateVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppEmbeddedSignupActivateMutationKey(),
		mutationFn: ({ organisationId }: WhatsAppEmbeddedSignupActivateVariables) =>
			whatsAppEmbeddedSignupActivate(organisationId, config).then(res => res.data),
		...options,
	})
}
